export default __webpack_public_path__ + "static/media/success.0212065b.svg";